import React from 'react';
import PropTypes from 'prop-types'
import {AppProvider, Page, TextField, FormLayout, Button} from "@shopify/polaris";
import translations from '@shopify/polaris/locales/es.json';
const propTypes ={
  error_message: PropTypes.array.isRequired,
  min_password_length: PropTypes.Number
}

class ResetPasswordForm extends React.Component {
  constructor(props){
    super(props)
    this.state={
      password: "",
      passwordConfirmation: "",
      errorPassword: props.error_message ? props.error_message.password : "",
      errorPasswordConfirmation:  props.error_message ? props.error_message.password_confirmation : "",
      minPassword: props.min_password_length
    }
  }
  handleChange = field => {
    return value => this.setState({ [field]: value });
  };

  render() {
    return(
        <AppProvider i18n={translations}>
          <Page>
            <FormLayout>
              <TextField
                  label={I18n.t("devise.actions.password")}
                  helpText={this.state.minPassword + I18n.t("devise.actions.password_length")}
                  value={this.state.password}
                  type="password"
                  name="user[password]"
                  onChange={this.handleChange("password")}
                  error={this.state.errorPassword}
              >
              </TextField>
              <TextField
                  label={I18n.t("devise.actions.password_confirmation")}
                  value={this.state.passwordConfirmation}
                  type="password"
                  name="user[password_confirmation]"
                  onChange={this.handleChange("passwordConfirmation")}
                  error={this.state.errorPasswordConfirmation}
              >
              </TextField>

              <Button primary submit>{I18n.t("devise.actions.reset_password")}</Button>
              <Button primary url="/users/sign_in">
                {I18n.t("devise.actions.log_in")}
              </Button>
              <Button url="/auth/shopify_per_user" id="shopifyLogin">
                {I18n.t("devise.actions.log_in_spofify")}
              </Button>
            </FormLayout>
          </Page>
        </AppProvider>
    )

  }

}

ResetPasswordForm.proptypes = propTypes;

export default ResetPasswordForm;